module.exports = __webpack_public_path__ + "assets/img/1_611_big.d535f3ef.jpg";